import {
	Component,
	Input
}                    from '@angular/core';
import { fadeInOut } from '@shared/animations/fadeInOut';

@Component( {
	selector: 'app-list-empty-result[listSize][emptyListMessage]',
	templateUrl: './list-empty-result.component.html',
	styleUrls: [ './list-empty-result.component.scss' ],
	animations: [ fadeInOut ]
} )
export class ListEmptyResultComponent {

	@Input() listSize: number;
	@Input() emptyListMessage: string;
	@Input() hideEmptyList: boolean;
}
